export const ACTION_TYPES = {
  GET_USER: 'authentication/GET_USER',
  LOGOUT: 'authentication/LOGOUT',
  CLEAR_AUTH: 'authentication/CLEAR_AUTH',
  ERROR_MESSAGE: 'authentication/ERROR_MESSAGE',
  FIND_SELLING_POINT: 'contract/FIND_SELLING_POINT',
};
